
import { Container, Row, Col, Nav } from "react-bootstrap";
import whyUsImg from "../assets/img/whyUsPic.png";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const WhyUs = () => {
 
  return (
    <section className="career">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h2>Why Us?</h2>
                <h4>Grow Your Business with us</h4>
                  <p>
                  OUR STRATEGY: Carry out a quick research to understand the client's need, quickly wireframe the project, make a design and implement same. One step at a time. And a small step. Valuable step. Putting the smaller pictures together. Advancing.
                  <br />
                    <br />Let’s Connect so you can learn more</p>
                  <button>Get A Free Quot by clicking the link bellow <ArrowRightCircle size={25} /></button>
                  <Nav className="subClass">
                  <Nav.Link href="/get-quote">Get Your Free 30-Mins Strategy Section Now!</Nav.Link>
                  </Nav>
                  <button>Read Our Latest Post <ArrowRightCircle size={25} /></button>
                 <Nav.Link href="/blog"><h3>* 5 Benefits of Hiring Professional Printing Services For Your Business</h3></Nav.Link><br />
                 <Nav.Link href="/five-advantages-of-using-a-professional-designer-for-your-business"><h3>* 5 Advantages Of Using A Professional Designer For Your Business</h3></Nav.Link><br /><br />
                                  
             </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={whyUsImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
